import { BreadcrumbsItemProps } from '@/components/ui/daisy/breadcrumbs/types';
import Observable from '@/utils/observers/ObserverPattern';
import { ROUTES } from '@/utils/routes';
import { CoursesNode } from '@/utils/trees/TreeCourses';
import { FolderIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';

export type BreadcrumbItem = Pick<
  BreadcrumbsItemProps,
  'href' | 'children' | 'icon'
> & {
  id: string;
  treeKey?: string;
};

export const adapterCourseNodeToBreadcrumbItem = (
  node: CoursesNode,
): BreadcrumbItem => {
  return {
    href: node.href,
    children: node.name,
    icon: <FolderIcon className="size-4" />,
    id: node.id,
    treeKey: node.id,
  };
};

export const useDynamicBreadcrumbItems = (
  finalMountTreeObserver?: Observable<string, CoursesNode[]>,
  initialPath: CoursesNode[] = [],
) => {
  const [path, setPath] = useState<CoursesNode[]>(initialPath);

  const base: BreadcrumbItem[] = [
    {
      href: '/',
      children: 'Home',
      icon: <FolderIcon className="size-4" />,
      id: 'root',
    },
    {
      href: ROUTES.COURSES.BASE,
      children: 'Cursos',
      icon: <FolderIcon className="size-4" />,
      id: 'course-lines',
    },
  ];

  const items = path.map(adapterCourseNodeToBreadcrumbItem).slice(1);

  useEffect(() => {
    if (finalMountTreeObserver)
      finalMountTreeObserver.subscribe({
        id: 'breadcrumb-subscriber',
        action: path => {
          setPath(path ?? []);
        },
      });

    return () => {
      if (finalMountTreeObserver)
        finalMountTreeObserver.unsubscribe('breadcrumb-subscriber');
    };
  }, [finalMountTreeObserver]);

  return [...base, ...items];
};
